import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import TopBar from "@/components/TopBar";
import { ArrowsClockwise, WarningCircle } from "@phosphor-icons/react";
import { toast } from "sonner";
import Footer from "@/components/Footer";

export default function Signals() {
  const nav = useNavigate();
  const [signals, setSignals] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get("/signals");
      setSignals(r.data.signals);
    } catch { toast.error("Load failed"); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const sev = {
    positive: "border-[#00e676] text-[#00e676]",
    negative: "border-[#ff3b30] text-[#ff3b30]",
    warning: "border-[#ffcc00] text-[#ffcc00]",
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <TopBar />
      <div className="px-6 py-5">
        <div className="flex items-end justify-between mb-5">
          <div>
            <div className="micro-label">/ live signals · watchlist</div>
            <h1 className="font-heading text-3xl mt-1">Active Alerts</h1>
          </div>
          <button onClick={load} className="flex items-center gap-1 px-3 py-1.5 border border-[#222] hover:border-[#444] text-xs font-mono-data uppercase tracking-wider"
            data-testid="signals-refresh">
            <ArrowsClockwise size={14} className={loading ? "animate-spin" : ""}/> Refresh
          </button>
        </div>

        {loading && <div className="text-center py-12 font-mono-data text-xs text-[#555]">SCANNING…</div>}
        {!loading && signals.length === 0 && (
          <div className="panel p-8 text-center">
            <WarningCircle size={28} className="mx-auto text-[#555] mb-2"/>
            <div className="font-mono-data text-xs text-[#8a8a8e]">NO ACTIVE SIGNALS · MARKET NEUTRAL</div>
          </div>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#222] border border-[#222]">
          {signals.map((s) => (
            <button
              key={`${s.symbol}-${s.type}`}
              onClick={() => nav(`/stock/${s.symbol}`)}
              className={`text-left bg-[#0f0f0f] hover:bg-[#1a1a1a] p-4 border-l-2 ${sev[s.severity]}`}
              data-testid={`signal-card-${s.symbol}-${s.type}`}
            >
              <div className="flex items-baseline justify-between">
                <span className="font-heading text-xl">{s.symbol}</span>
                <span className="font-mono-data text-sm">${s.price.toFixed(2)}</span>
              </div>
              <div className="font-mono-data text-[10px] uppercase tracking-widest mt-2 text-[#8a8a8e]">{s.type.replace(/_/g," ")}</div>
              <div className="text-sm mt-1 font-mono-data">{s.message}</div>
            </button>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
